import React, { forwardRef, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';

import ReactTable from 'components/ReactTable/ReactTable.js';
import { wsGetAll } from 'services/WService';
import { Done } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  grid: {
    height: '100%',
    marginTop: '20px'
  }
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false,width: 120 },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'Acciones', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default function ModalSearch(props) {
  const classes = useStyles();
  const { showModal, setShowModal } = props;

  const handleClose = () => {
    setShowModal(false);
  };

  const [routes, setRoutes] = useState([]); //constante para el listado

  async function loadRoutes() {
    let response = await wsGetAll('base/route');
    if (response.success) setRoutes(response.data);
  }

  useEffect(() => {
    if (showModal) {
      loadRoutes();
    }
  }, [showModal]);

  return (
    <Dialog fullScreen open={showModal} onClose={handleClose} TransitionComponent={Transition}>
      <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Listado de rutas
            </Typography>
          </Toolbar>
        </AppBar>
        <GridItem xs={12} sm={12} md={12} className={classes.grid}>
          <ReactTable
            exportExcel={false}
            columns={columns}
            data={routes.map((route, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      size="sm"
                      round
                      style={{marginLeft: '15px' }}
                      onClick={() => {
                        props.search(route.description);
                        props.setSearch(route.description);
                        handleClose();
                      }}
                      color="success"
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                code: route.code,
                description: route.description,
                zone: route.base_zone_description,
                state: route.state === 'A' ? 'Activo' : 'Inactivo',
                actions: ''
              };
            })}
          />
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
